import moment from 'moment'
import momentTz from 'moment-timezone'

const formatDate = function (date, format = 'DD MMMM YYYY H:mm') {
  return date ? moment(date).format(format) : ''
}

const formatDateWithTz = function (date, tz, format = 'DD MMMM YYYY H:mm') {
  return date ? momentTz.tz(date, tz).format(format) : ''
}

const formatDateWithTzName = function (date) {
  return date ? moment.tz(date).zoneAbbr() : ''
}

export { formatDate, formatDateWithTz, formatDateWithTzName }



// WEBPACK FOOTER //
// ./src/helpers/date.js